<template>
<div class="home-panel">
  <div class="home-panel-container">
    <div class="img-container">
      <img :src="background" class="img-responsive">
    </div>
    <div class="home-panel-caption">
      <slot name="default"></slot>
    </div>
  </div>
</div>
</template>
<script>
export default {
  name: 'home-panel',
  props: {
    background: {
      type: String,
      required: true
    }
  }
}
</script>
<style scoped lang="less">
@import "~variables";
.home-panel {
  border-radius: 0.5rem;
  overflow: hidden;

  @media (min-width: 0) and (max-width: @screen-md-max) {
    margin-bottom: 1rem;
  }
}

.home-panel-container {
  .img-container {
    max-height: 130px;
    overflow: hidden;
  }
}

.home-panel-caption {
  padding: 2rem;
  background-color: rgba(255, 255, 255, 0.85);
  bottom: 10%;
  color: @base-text;
  text-shadow: none;

  h3 {
    color: @dark-base;
    margin-top: 0rem;
  }

  li {
    list-style: circle;
  }

  hr {
    border-color: @dark-base;
  }

  position: initial;
  width: 100%;
}
</style>
